import { useMemo } from "react";

const Particles = () => {
  // useMemo sorgt dafür, dass die Partikel nur einmal erstellt werden
  const particles = useMemo(() => {
    return [...Array(50)].map((_, i) => ({
      id: i,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      speed: Math.random() * 10 + 5,
      size: Math.random() * 15 + 10,
      opacity: Math.random() * 0.7 + 0.3,
      animationDuration: Math.random() * 6 + 4,
    }));
  }, []); // Leeres Array -> wird nur beim ersten Render erstellt

  return (
    <div className="absolute inset-0 overflow-hidden blur-sm pointer-events-none">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="particle-wrapper absolute"
          data-speed={particle.speed}
          style={{
            top: particle.top,
            left: particle.left,
          }}
        >
          <div
            className="particle rounded-full"
            style={{
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              background: `rgba(255, 112, 81, ${particle.opacity})`,
              boxShadow: `0 0 20px rgba(255, 112, 81, 0.4)`,
              animation: `float ${particle.animationDuration}s ease-in-out infinite`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Particles;
